// @ts-ignore
import React, { HTMLAttributes } from "react";

import { css } from "@compiled/react";

import { media } from "@atlaskit/primitives/responsive";

export const Table = (props: HTMLAttributes<HTMLTableElement>) => {
    return <table {...props} css={tableCss} />;
};

const tableCss = css({
    flexDirection: "column",
    tableLayout: "fixed",
    width: "100%",
    padding: 0,
    border: 0,
    textAlign: "center",
    borderCollapse: "collapse",
    borderSpacing: 0,
    [media.below.sm]: {
        display: "flex"
    },
    display: "table"
});
